import { TextField } from 'mui-rff';
import React from 'react';

import { type InputProps } from '@mui/material';

type Props = {
  label: string;
  name: string;
  rows?: number;
  autohighlight?: boolean;
  autofocus?: boolean;
  placeholder?: string;
  helperText?: string | JSX.Element;
  InputProps?: InputProps;
};
export default function TextInput({
  helperText,
  label,
  autohighlight,
  autofocus,
  placeholder,
  rows,
  name,
  InputProps,
}: Props) {
  const isMultiline = typeof rows === 'number' && rows > 1;
  return (
    <TextField
      autoFocus={autofocus}
      fullWidth
      multiline={isMultiline}
      minRows={rows}
      variant={isMultiline ? 'outlined' : 'standard'}
      label={label}
      name={name}
      placeholder={placeholder}
      onFocus={(event) => {
        if (autohighlight) {
          event.target.select();
        }
      }}
      helperText={helperText}
      InputProps={InputProps}
    />
  );
}
